import React from 'react';
import ReactDOM from 'react-dom';
import Router from './router/Router';
// import App from './App';

ReactDOM.render(<Router />, document.getElementById('root'));
